export default {"src":"/_next/static/media/imgur.c5f5e38d.svg","height":54,"width":150,"blurWidth":0,"blurHeight":0};